<template>
    <div class="row d-flex justify-content-center">
        <div class="col-lg-8 col-md-12">
            <card>
                <tabs type="info" :value="activeTab">
                    <tab-pane
                        link="/account/general"
                        label="General"
                        class="py-4 px-2"
                    >
                        <account-edit
                            :me="me"
                            :password-min-length="passwordMinLength"
                            @updateMe="updateMe"
                        />
                    </tab-pane>
                    <tab-pane link="/account/settings" label="Settings">
                        <account-settings :is-client="isClient" />
                    </tab-pane>
                </tabs>
            </card>
        </div>
        <div class="col-lg-4 col-md-12">
            <user-profile-card :user="me" />
        </div>
    </div>
</template>
<script>
import { TabPane, Tabs } from "src/components/UI";

import UserProfileCard from "src/components/UserProfileCard.vue";
import AccountEdit from "./AccountEdit.vue";
import AccountSettings from "./AccountSettings.vue";

export default {
    name: "Account",
    components: {
        TabPane,
        Tabs,
        AccountEdit,
        AccountSettings,
        UserProfileCard,
    },
    props: {
        me: {
            type: Object,
            required: true,
        },
        passwordMinLength: {
            type: Number,
            required: true,
        },
        activeTab: {
            type: String,
            required: true,
        },
        isClient: {
            type: Boolean,
            required: true,
        },
    },
    methods: {
        updateMe(update) {
            this.$emit("updateMe", update);
        },
    },
};
</script>
